import { render, staticRenderFns } from "./PublicOrder.vue?vue&type=template&id=495b475d&scoped=true"
import script from "./PublicOrder.vue?vue&type=script&lang=js"
export * from "./PublicOrder.vue?vue&type=script&lang=js"
import style0 from "./PublicOrder.vue?vue&type=style&index=0&id=495b475d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b475d",
  null
  
)

export default component.exports